import styled from "@emotion/styled";
import Typography from "@mui/material/Typography";
import AutocompleteField from "shared/components/Form/AutocompleteField";
import {
  COLOR_GREY_5,
  BORDER,
  COLOR_GREY100,
  COLOR_PRIMARY_MAIN,
} from "shared/theme/colors";
import { border, flex } from "shared/theme/mixins";

export const StyledOption = styled("li")`
  ${flex({ ai: "center" })}
  height: 40px;
  padding: 0;
  border-bottom: ${BORDER(1, COLOR_GREY_5)};

  :last-of-type {
    border: none;
  }
`;

export const StyledOptionText = styled(Typography)`
  cursor: pointer;
`;

export const StyledAutocomplete = styled(AutocompleteField, {
  shouldForwardProp: (props) => props !== "isOpened",
})<{
  isOpened?: boolean;
}>`
  .MuiAutocomplete-option {
    padding: 0;
  }

  .MuiFormControl-root {
    height: 40px;
    border-radius: 0.75rem;
    border: none;

    .MuiOutlinedInput-root input {
      padding: 0 1rem;
      font-size: 14px;
    }

    .MuiOutlinedInput-root {
      padding: 0;
      height: 40px;

      &.Mui-focused {
        .MuiOutlinedInput-notchedOutline {
          ${border(1, COLOR_GREY100)}
        }

        textarea.MuiOutlinedInput-input {
          padding: 1rem;
        }
      }

      :hover {
        .MuiOutlinedInput-notchedOutline {
          ${border(1, COLOR_GREY100)}
        }
      }
    }

    .MuiOutlinedInput-notchedOutline {
      border-radius: ${({ isOpened }) =>
        isOpened ? "0.5rem 0.5rem 0 0 " : "0.5rem"};
      ${border(1, COLOR_GREY100)}
    }
  }
`;

export const CustomMenuStyles = {
  "&.MuiPaper-root": {
    boxShadow: "0px 2px 24px 0px rgba(0, 0, 0, 0.05)",
    borderRadius: "0 0 8px 8px",
    border: BORDER(1, COLOR_GREY_5),
    borderTop: "none",

    "> div": {
      borderTop: BORDER(2, COLOR_PRIMARY_MAIN),
      padding: "0 1rem",
    },
  },
};
